import styled from 'styled-components'

import { helpers } from 'styles'

type Props = {
	hasHeader?: boolean
}

export const Container = styled.div<Props>`
	background-color: ${helpers.color.textContrast};
	border: 1px solid ${helpers.color.border};
	overflow-wrap: break-word;
	border-radius: 12px;
	padding: ${({ hasHeader }) => (hasHeader ? '16px 24px 24px' : '24px 24px 24px')};
	height: fit-content;
`
